var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.savedResource)?_c('span',[_c('b-icon-bookmark-fill')],1):_c('span',[_c('b-icon-bookmark')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }